import { HydrateOption } from '@core/enums';
import { Grid } from '@helpers/grid';
import withWidget from '@hoc/withWidget';
import { ReactComponent as Chevron } from '@img/icons/chevron.svg';
import Heading from '@stories/Components/Global/Typography/Heading';
import React from 'react';
import { FAQListStyles as S } from './FAQList.styles';
import { ThemeWrapper } from '@helpers/theme';
const FAQList = (props) => {
    const [activeFAQ, setActiveFAQ] = React.useState(-1);
    if (!props.faqs || props.faqs.length === 0) {
        return null;
    }
    return (React.createElement(ThemeWrapper, { "data-theme": props.theme },
        React.createElement(S.BackgroundContainer, null,
            React.createElement(Grid.Default, null,
                React.createElement(S.Container, null,
                    props.title && (React.createElement(Heading, { semantic: "h2", visual: "h5" }, props.title)),
                    React.createElement(S.FAQs, null, props.faqs.map((x, i) => (React.createElement(S.FAQ, { key: x.question, isActive: activeFAQ === i },
                        React.createElement(S.FAQQuestion, { onClick: () => setActiveFAQ(activeFAQ === i ? -1 : i) },
                            x.question,
                            React.createElement(Chevron, null)),
                        React.createElement(S.FAQAnswer, { dangerouslySetInnerHTML: { __html: x.answer } }))))))))));
};
export default withWidget(FAQList, 'FAQList', { hydrate: HydrateOption.InView });
